import styled from 'styled-components'
import { Link } from 'react-router-dom'

import constants from 'utils/constants'

import TitleHeader from 'components/presenters/header/TitleHeader'
import SVGIcon from 'components/modules/common/SVGIcon'

export default function CharmdenEventPage() {
  return (
    <Wrapper>
      <HeaderBlock>
        <TitleHeader title="나에게 맞는 건강즙은?" isCloseBtn={true} />
      </HeaderBlock>
      <Description>
        <DescImage src={`${constants.imagePath}/common/event/charmden/charmden-first.jpg`} />
      </Description>
      <Description>
        <DescImage src={`${constants.imagePath}/common/event/charmden/charmden-second.jpg`} />
      </Description>
      <ButtonBlock>
        <Button to="/motishop">나에게 맞는 건강즙 구경하기</Button>
      </ButtonBlock>
      <Description>
        <DescImage src={`${constants.imagePath}/common/event/charmden/charmden-third.jpg`} />
      </Description>
      <ButtonBlock>
        <Button to="/motishop">참든 건강즙 구경하기</Button>
      </ButtonBlock>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-y: scroll;
`

const HeaderBlock = styled.div`
  flex: 0 1 auto;
  min-height: calc(100vw * (51 / 375));
`

const Description = styled.div`
  width: 100%;
`

const DescImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const ButtonBlock = styled.div`
  padding-right: calc(100vw * (17 / 375));
  padding-left: calc(100vw * (17 / 375));
  margin-top: calc(100vw * (20 / 375));
  margin-bottom: calc(100vw * (31 / 375));
`

const Button = styled(Link)`
  background-color: #ffcf19;
  border-radius: calc(100vw * (10 / 375));
  width: 100%;
  padding: calc(100vw * (20 / 375)) 0;
  text-align: center;
  font-size: calc(100vw * (20 / 375));
  font-weight: 700;
  line-height: calc(100vw * (28 / 375));
`
